<script>
import { Query } from "@sveltestack/svelte-query"
import { startOfWeek, endOfWeek, format } from "date-fns"
import API from "@local/utils/api"
import List from "@local/components/List.svelte"
import EmptyMessage from "@local/components/EmptyMessage.svelte"
import TextInput from "@local/components/form/TextInput.svelte"
import Select from "@local/components/form/Select.svelte"
import Icon from "@local/components/images/Icon.svelte"
import { onMount } from "svelte" // Importe onMount
import * as XLSX from "xlsx"
import BackToTop from "@local/components/BackToTop.svelte"

let queryVal = ""
let fromDateVal = format(startOfWeek(new Date()), "yyyy-MM-dd")
let toDateVal = format(endOfWeek(new Date()), "yyyy-MM-dd")
let filters = {
  query: "",
  publishedAtFrom: `${fromDateVal}T00:00:00.000Z`,
  publishedAtTo: `${toDateVal}T23:59:59.999Z`,
}
let doctorOptions = ["Yong Sun Lee"]

function search() {
  const newFilters = {
    query: queryVal,
  }
  if (fromDateVal) newFilters.publishedAtFrom = `${fromDateVal}T00:00:00.000Z`
  if (toDateVal) newFilters.publishedAtTo = `${toDateVal}T23:59:59.999Z`
  filters = newFilters
}

async function fetchWorkflows(filters) {
  const defKey = "admMDBillingReport"
  const searchParams = {
    role: "admin",
    page: 0,
    perPage: 10000000,
    ...filters,
  }
  const response = await API.get(`lists/def-key/${defKey}`, { searchParams })
  const rows = await response.json()

  return { rows }
}

function buildFileName(queryVal) {
  const doctorFirstName = queryVal?.split(" ")?.[0]?.toLowerCase() || ""
  const month = format(new Date(), "MMM").toLowerCase()
  return doctorFirstName + "-" + month
}

function downloadXLSX(rows, queryVal) {
  if (!rows || rows.length === 0) return
  const header = rows[0].columns.map((row) => row.label)
  const data = rows.map((row) => row.columns.map((col) => col.value))
  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data])
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report")
  const fileName = buildFileName(queryVal) + ".xlsx"
  XLSX.writeFile(workbook, fileName)
}

$: queryOptions = {
  queryKey: ["reports/md-billing", JSON.stringify(filters)],
  queryFn: () => fetchWorkflows(filters),
  keepPreviousData: true,
  refetchOnWindowFocus: false,
}
</script>

<Query options="{queryOptions}">
  <div class="p-5" slot="query" let:queryResult>
    {#if queryResult.isLoading}
      <div></div>
    {:else if queryResult.error}
      <EmptyMessage icon="error">{queryResult.error}</EmptyMessage>
    {:else}
      <div class="flex flex-row items-center justify-between mb-6">
        <h2 class="h2">Report: MD Billing</h2>
      </div>
      <div class="flex items-end gap-2 mb-2">
        <form
          class="flex items-end w-full gap-2"
          on:submit|preventDefault="{search}"
        >
          <TextInput bind:value="{fromDateVal}" label="From" type="date" />
          <TextInput bind:value="{toDateVal}" label="To" type="date" />
          <Select
            bind:value="{queryVal}"
            options="{doctorOptions}"
            label="Doctors"
            placeholder="Doctors"
          />
          <button
            class="flex items-center justify-center flex-shrink-0 w-10 h-10 btn btn-outline"
            type="submit"><Icon size="3xl">search</Icon></button
          >

          {#if queryResult.data.rows.length > 0}
            <button
              class="flex items-center justify-center flex-shrink-0 w-10 h-10 btn btn-outline"
              type="button"
              on:click="{() => downloadXLSX(queryResult.data.rows, queryVal)}"
              title="Download XLSX"
            >
              <Icon size="3xl">download</Icon>
            </button>
          {/if}
        </form>
      </div>
      {#if queryResult.data.rows.length > 0}
        <List rows="{queryResult.data.rows}" />
      {:else}
        <EmptyMessage icon="check">No records</EmptyMessage>
      {/if}
    {/if}
  </div>
</Query>

<BackToTop />
